import styled from 'styled-components';

const ActivityViewStyled = styled.div`
  .result-wrap {
    background: #fff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 24px 32px 56px;
  }
  .btn-wrap {
    background: #fff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    margin-top: 4px;
    padding: 24px 32px;
  }
`;
export default ActivityViewStyled;
